<template>
  <div id="top_bar">
    <div v-if="isSnowing" class="snow">
      <div></div>
    </div>
    <Transition name="open-window-transition">
      <ssh-editor :initShh="userInfo.settings.ssh" @updated="onUpdateSSH" @close="sshEditor.show= false" v-if="sshEditor.show"/>
    </Transition>

    <div class="bar_container">
      <div class="bar_container__item left_container">
        <div
          @click="switchHide"
          class="left_container__item hide_button"
          :class="hide ? 'reversed' : ''"
        >
          <button>
            <svg
              width="24"
              height="16"
              viewBox="0 0 24 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.75 15.5V13H17V15.5H0.75ZM21.5 14.25L15.25 8L21.5 1.75L23.25 3.5L18.75 8L23.25 12.5L21.5 14.25ZM0.75 9.25V6.75H13.25V9.25H0.75ZM0.75 3V0.5H17V3H0.75Z"
                fill="white"
              />
            </svg>
          </button>
        </div>
        <div class="left_container__item logo_container" @click="goFirstPage">
          <div class="logo_container__item">
            <svg
              v-if="isSnowing"
              height="44px"
              width="44px"
              id="_x35_"
              viewBox="0 0 312 512"
              xml:space="preserve"
              fill="#000000"
            >
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                <g>
                  <g>
                    <path
                      style="fill: #f3d042"
                      d="M135.539,2.417c1.425-3.223,3.742-3.223,5.161,0l5.48,12.434c1.425,3.223,5.444,5.541,8.939,5.155 l13.514-1.473c3.483-0.375,4.653,1.635,2.577,4.472l-8.027,10.967c-2.082,2.837-2.082,7.485,0,10.321l8.027,10.968 c2.076,2.836,0.906,4.846-2.577,4.46l-13.514-1.46c-3.495-0.38-7.515,1.944-8.939,5.161l-5.48,12.428 c-1.419,3.223-3.736,3.223-5.161,0l-5.487-12.428c-1.418-3.217-5.438-5.541-8.933-5.161l-13.508,1.46 c-3.495,0.386-4.666-1.624-2.583-4.46l8.027-10.968c2.077-2.836,2.077-7.484,0-10.321l-8.027-10.967 c-2.082-2.837-0.912-4.847,2.583-4.472l13.508,1.473c3.494,0.386,7.515-1.931,8.933-5.155L135.539,2.417z"
                    ></path>
                  </g>
                  <g>
                    <path
                      style="fill: #9d897e"
                      d="M175.744,497.611c0,7.949-6.434,14.389-14.389,14.389h-46.488c-7.943,0-14.378-6.44-14.378-14.389 v-91.298c0-7.949,6.434-14.383,14.378-14.383h46.488c7.955,0,14.389,6.434,14.389,14.383V497.611z"
                    ></path>
                    <path
                      style="fill: #917d73"
                      d="M175.744,497.611v-91.298l-47.116-14.383h-14.619l-12.687,46.506L141.062,512h20.293 C169.31,512,175.744,505.56,175.744,497.611z"
                    ></path>
                  </g>
                  <g>
                    <path
                      style="fill: #e8d822"
                      d="M241.631,325.752c-3.995-5.746-3.277-13.514,1.69-18.427l11.474-11.347 c5.137-5.095,5.698-13.201,1.304-18.959l-42.233-55.325c-4.6-6.024-3.731-14.589,1.985-19.574l4.563-3.959 c5.861-5.113,6.61-13.949,1.678-19.967l-72.853-88.926c-2.722-3.331-6.809-5.263-11.124-5.263c-4.304,0-8.39,1.932-11.124,5.263 l-72.846,88.926c-4.932,6.018-4.189,14.854,1.677,19.967l4.569,3.959c5.716,4.985,6.579,13.551,1.98,19.574l-42.239,55.325 c-4.388,5.758-3.826,13.864,1.316,18.959l11.468,11.347c4.961,4.913,5.679,12.681,1.69,18.427L2.575,371.878 c-2.668,3.827-3.302,8.71-1.72,13.104c1.594,4.376,5.209,7.72,9.699,8.958l123.741,34.145c2.505,0.682,5.143,0.682,7.654,0 l123.729-34.145c4.496-1.237,8.112-4.582,9.699-8.958c1.582-4.394,0.947-9.277-1.708-13.104L241.631,325.752z"
                    ></path>
                    <path
                      style="fill: #ffffff"
                      d="M256.099,277.018l-3.241-4.244L1.628,373.441c-1.841,3.549-2.149,7.726-0.773,11.54 c0.525,1.431,1.268,2.753,2.185,3.93l255.993-102.579C259.16,283.078,258.212,279.783,256.099,277.018z"
                    ></path>
                    <path
                      style="fill: #69af32"
                      d="M213.867,221.694c-4.6-6.024-3.731-14.589,1.985-19.574l4.563-3.959 c5.861-5.113,6.61-13.949,1.678-19.967l-2.613-3.187L44.489,245.119l-24.355,31.9c-4.388,5.758-3.826,13.864,1.316,18.959 l11.468,11.347c4.961,4.913,5.679,12.681,1.69,18.427L2.575,371.878c-0.35,0.501-0.67,1.026-0.947,1.564l251.231-100.667 L213.867,221.694z"
                    ></path>
                    <path
                      style="fill: #d8281c"
                      d="M10.555,393.939l123.741,34.145c2.505,0.682,5.143,0.682,7.654,0l123.729-34.145 c4.496-1.237,8.112-4.582,9.699-8.958c1.582-4.394,0.947-9.277-1.708-13.104l-32.038-46.126 c-3.995-5.746-3.277-13.514,1.69-18.427l11.474-11.347c2.668-2.65,4.092-6.121,4.238-9.646L3.04,388.911 C4.917,391.319,7.537,393.106,10.555,393.939z"
                    ></path>
                    <polygon
                      style="fill: #ffffff"
                      points="209.78,163.164 61.781,222.473 44.489,245.119 219.48,175.007 "
                    ></polygon>
                  </g>
                </g>
              </g>
            </svg>
            <svg
              v-else
              width="40"
              height="39"
              viewBox="0 0 40 39"
              fill="none"
            >
              <path
                d="M19.5938 0.181878C19.2734 0.361917 19.2578 0.502817 19.2188 3.60262L19.1797 6.60066L12.1094 9.64567C8.22656 11.3286 4.97656 12.769 4.88281 12.8551C4.72656 13.0116 4.72656 13.0977 4.6875 21.7866L4.64844 30.5615L2.53906 31.5009C0.351562 32.4637 0 32.6829 0 33.0899C0 33.5361 0.367188 33.9118 0.789062 33.9118C0.890625 33.9118 1.96094 33.4735 3.17188 32.9333C4.38281 32.3932 5.42188 31.9549 5.48438 31.9549C5.53906 31.9549 8.77344 33.3326 12.6641 35.0077C17.1406 36.9333 19.8438 38.0605 20 38.0605C20.1562 38.0605 22.8594 36.9333 27.3359 35.0077C31.2266 33.3326 34.4609 31.9549 34.5156 31.9549C34.5781 31.9549 35.6172 32.3932 36.8281 32.9333C38.0391 33.4735 39.1094 33.9118 39.2109 33.9118C39.6328 33.9118 40 33.5361 40 33.0899C40 32.6829 39.6484 32.4637 37.4609 31.5009L35.3516 30.5615L35.3125 21.7866C35.2734 13.0977 35.2734 13.0116 35.1172 12.8551C35.0234 12.769 31.7734 11.3286 27.8906 9.64567L20.8203 6.60066L20.7812 3.60262C20.7422 0.479334 20.7266 0.354089 20.3906 0.17405C20.2031 0.0722888 19.7656 0.0801166 19.5938 0.181878ZM19.2188 9.33256C19.2188 10.6711 19.3672 10.9764 20 10.9764C20.6328 10.9764 20.7812 10.6711 20.7812 9.33256C20.7812 8.77679 20.7969 8.31495 20.8125 8.31495C20.8516 8.31495 32.2578 13.2386 32.3984 13.3169C32.4844 13.3639 32.3359 13.4578 31.8594 13.6613C31.5078 13.8101 28.7188 15.0155 25.6641 16.3384C21.9297 17.951 20.0547 18.7259 19.9219 18.7024C19.7578 18.6789 7.9375 13.5987 7.60156 13.4108C7.52344 13.3717 8.60938 12.8629 10.9141 11.8766C12.7969 11.0625 15.4062 9.92747 16.7188 9.36387C18.0312 8.79245 19.125 8.32278 19.1641 8.32278C19.1953 8.31495 19.2188 8.77679 19.2188 9.33256ZM12.7422 17.3482L19.1797 20.1271L19.2031 28.1114C19.2109 32.5106 19.2031 36.1036 19.1875 36.1036C19.1484 36.1036 7.72656 31.1799 7.58594 31.0938C7.45312 31.0234 7.50781 30.9999 9.27344 30.2171C10.1719 29.8257 10.3906 29.6222 10.3906 29.1995C10.3906 28.8003 10.0547 28.4324 9.6875 28.4324C9.54688 28.4324 8.85156 28.6907 8.09375 29.0273C7.35938 29.356 6.64062 29.677 6.50781 29.7318L6.25 29.8414V22.2093C6.25 18.0136 6.26562 14.5772 6.28125 14.5772C6.29688 14.5772 9.20312 15.8218 12.7422 17.3482ZM33.75 22.2093V29.8414L33.5 29.7318C33.3594 29.677 32.6406 29.356 31.9062 29.0273C31.1484 28.6907 30.4531 28.4324 30.3125 28.4324C29.9453 28.4324 29.6094 28.8003 29.6094 29.1995C29.6094 29.6222 29.8281 29.8257 30.7266 30.2171C32.4922 30.9999 32.5469 31.0234 32.4141 31.0938C32.2734 31.1799 20.8516 36.1036 20.8125 36.1036C20.7969 36.1036 20.7891 32.5106 20.7969 28.1114L20.8203 20.1271L27.2266 17.356C30.75 15.8375 33.6562 14.585 33.6953 14.585C33.7266 14.5772 33.75 18.0136 33.75 22.2093Z"
                fill="white"
              />
              <path
                d="M19.4922 12.808C19.2422 13.0585 19.1797 13.3481 19.2969 13.6456C19.4297 13.9509 19.6562 14.1074 20 14.1074C20.3437 14.1074 20.5703 13.9509 20.7031 13.6456C20.9062 13.1446 20.5469 12.6201 20 12.6201C19.7656 12.6201 19.6328 12.6671 19.4922 12.808Z"
                fill="white"
              />
              <path
                d="M11.9921 27.3686C11.7421 27.619 11.6796 27.9087 11.7968 28.2061C11.9296 28.5114 12.1562 28.668 12.4999 28.668C12.8437 28.668 13.0702 28.5114 13.203 28.2061C13.4062 27.7052 13.0468 27.1807 12.4999 27.1807C12.2655 27.1807 12.1327 27.2277 11.9921 27.3686Z"
                fill="white"
              />
              <path
                d="M26.9921 27.3686C26.7421 27.619 26.6796 27.9087 26.7968 28.2061C26.9296 28.5114 27.1562 28.668 27.4999 28.668C27.8437 28.668 28.0702 28.5114 28.203 28.2061C28.4062 27.7052 28.0468 27.1807 27.4999 27.1807C27.2655 27.1807 27.1327 27.2277 26.9921 27.3686Z"
                fill="white"
              />
            </svg>
          </div>
          <div class="left_container__item">
            <svg
              width="111"
              height="20"
              viewBox="0 0 111 20"
              fill="none"
            >
              <path
                d="M8.63037 1.72656V19.5H6.31104V1.72656H8.63037ZM14.3433 1.72656V3.65527H0.610352V1.72656H14.3433ZM23.5352 12.5298H18.7866V10.6133H23.5352C24.4548 10.6133 25.1994 10.4668 25.769 10.1738C26.3387 9.88086 26.7537 9.47396 27.0142 8.95312C27.2827 8.43229 27.417 7.83822 27.417 7.1709C27.417 6.56055 27.2827 5.98682 27.0142 5.44971C26.7537 4.9126 26.3387 4.48128 25.769 4.15576C25.1994 3.8221 24.4548 3.65527 23.5352 3.65527H19.3359V19.5H16.98V1.72656H23.5352C24.8779 1.72656 26.0132 1.9585 26.9409 2.42236C27.8687 2.88623 28.5726 3.52913 29.0527 4.35107C29.5329 5.16488 29.7729 6.09668 29.7729 7.14648C29.7729 8.28581 29.5329 9.2583 29.0527 10.064C28.5726 10.8696 27.8687 11.484 26.9409 11.9072C26.0132 12.3223 24.8779 12.5298 23.5352 12.5298ZM34.8633 0.75V19.5H32.5928V0.75H34.8633ZM46.2769 17.2417V10.4424C46.2769 9.92155 46.1711 9.46989 45.9595 9.0874C45.756 8.69678 45.4468 8.39567 45.0317 8.18408C44.6167 7.97249 44.104 7.8667 43.4937 7.8667C42.924 7.8667 42.4235 7.96436 41.9922 8.15967C41.569 8.35498 41.2354 8.61133 40.9912 8.92871C40.7552 9.24609 40.6372 9.58789 40.6372 9.9541H38.3789C38.3789 9.4821 38.501 9.01416 38.7451 8.55029C38.9893 8.08643 39.3392 7.66732 39.7949 7.29297C40.2588 6.91048 40.8122 6.60938 41.4551 6.38965C42.1061 6.16178 42.8304 6.04785 43.6279 6.04785C44.5882 6.04785 45.4346 6.21061 46.167 6.53613C46.9076 6.86165 47.4854 7.354 47.9004 8.01318C48.3236 8.66423 48.5352 9.4821 48.5352 10.4668V16.6191C48.5352 17.0586 48.5718 17.5265 48.645 18.0229C48.7264 18.5194 48.8444 18.9466 48.999 19.3047V19.5H46.6431C46.5291 19.2396 46.4396 18.8937 46.3745 18.4624C46.3094 18.0229 46.2769 17.616 46.2769 17.2417ZM46.6675 11.4922L46.6919 13.0791H44.4092C43.7663 13.0791 43.1925 13.132 42.688 13.2378C42.1834 13.3354 41.7603 13.486 41.4185 13.6895C41.0767 13.8929 40.8162 14.1493 40.6372 14.4585C40.4582 14.7596 40.3687 15.1136 40.3687 15.5205C40.3687 15.9355 40.4622 16.314 40.6494 16.6558C40.8366 16.9976 41.1174 17.2702 41.4917 17.4736C41.8742 17.6689 42.3421 17.7666 42.8955 17.7666C43.5872 17.7666 44.1976 17.6201 44.7266 17.3271C45.2555 17.0342 45.6746 16.6761 45.9839 16.2529C46.3013 15.8298 46.4722 15.4188 46.4966 15.02L47.4609 16.1064C47.404 16.4482 47.2493 16.8267 46.9971 17.2417C46.7448 17.6567 46.4071 18.0555 45.9839 18.438C45.5688 18.8123 45.0724 19.1257 44.4946 19.3779C43.925 19.6221 43.2821 19.7441 42.5659 19.7441C41.6707 19.7441 40.8854 19.5692 40.21 19.2192C39.5426 18.8693 39.0218 18.4014 38.6475 17.8154C38.2812 17.2214 38.0981 16.5581 38.0981 15.8257C38.0981 15.1177 38.2365 14.4951 38.5132 13.958C38.7899 13.4128 39.1886 12.9611 39.7095 12.603C40.2303 12.2368 40.8569 11.9601 41.5894 11.7729C42.3218 11.5858 43.1396 11.4922 44.043 11.4922H46.6675ZM57.6172 6.29199V8.02539H50.4761V6.29199H57.6172ZM52.8931 3.08154H55.1514V16.2285C55.1514 16.6761 55.2205 17.0138 55.3589 17.2417C55.4972 17.4696 55.6763 17.6201 55.896 17.6934C56.1157 17.7666 56.3517 17.8032 56.604 17.8032C56.7912 17.8032 56.9865 17.7869 57.1899 17.7544C57.4015 17.7137 57.5602 17.6812 57.666 17.6567L57.6782 19.5C57.4992 19.557 57.2632 19.6099 56.9702 19.6587C56.6854 19.7157 56.3395 19.7441 55.9326 19.7441C55.3792 19.7441 54.8706 19.6343 54.4067 19.4146C53.9429 19.1948 53.5726 18.8286 53.2959 18.3159C53.0273 17.7951 52.8931 17.0952 52.8931 16.2163V3.08154ZM63.6353 19.5H61.377V4.90039C61.377 3.94824 61.5479 3.14665 61.8896 2.49561C62.2396 1.83643 62.7401 1.34001 63.3911 1.00635C64.0422 0.664551 64.8153 0.493652 65.7104 0.493652C65.9709 0.493652 66.2313 0.509928 66.4917 0.54248C66.7603 0.575033 67.0207 0.623861 67.2729 0.688965L67.1509 2.53223C66.98 2.49154 66.7847 2.46305 66.5649 2.44678C66.3534 2.4305 66.1418 2.42236 65.9302 2.42236C65.45 2.42236 65.035 2.52002 64.6851 2.71533C64.3433 2.90251 64.0828 3.1792 63.9038 3.54541C63.7248 3.91162 63.6353 4.36328 63.6353 4.90039V19.5ZM66.4429 6.29199V8.02539H59.2896V6.29199H66.4429ZM68.3594 13.0425V12.7617C68.3594 11.8096 68.4977 10.9266 68.7744 10.1128C69.0511 9.29085 69.4499 8.57878 69.9707 7.97656C70.4915 7.36621 71.1222 6.89421 71.8628 6.56055C72.6034 6.21875 73.4334 6.04785 74.353 6.04785C75.2808 6.04785 76.1149 6.21875 76.8555 6.56055C77.6042 6.89421 78.2389 7.36621 78.7598 7.97656C79.2887 8.57878 79.6916 9.29085 79.9683 10.1128C80.245 10.9266 80.3833 11.8096 80.3833 12.7617V13.0425C80.3833 13.9946 80.245 14.8776 79.9683 15.6914C79.6916 16.5052 79.2887 17.2173 78.7598 17.8276C78.2389 18.4299 77.6082 18.9019 76.8677 19.2437C76.1353 19.5773 75.3052 19.7441 74.3774 19.7441C73.4497 19.7441 72.6156 19.5773 71.875 19.2437C71.1344 18.9019 70.4997 18.4299 69.9707 17.8276C69.4499 17.2173 69.0511 16.5052 68.7744 15.6914C68.4977 14.8776 68.3594 13.9946 68.3594 13.0425ZM70.6177 12.7617V13.0425C70.6177 13.7017 70.695 14.3242 70.8496 14.9102C71.0042 15.488 71.2362 16.0007 71.5454 16.4482C71.8628 16.8958 72.2575 17.2498 72.7295 17.5103C73.2015 17.7625 73.7508 17.8887 74.3774 17.8887C74.9959 17.8887 75.5371 17.7625 76.001 17.5103C76.473 17.2498 76.8636 16.8958 77.1729 16.4482C77.4821 16.0007 77.714 15.488 77.8687 14.9102C78.0314 14.3242 78.1128 13.7017 78.1128 13.0425V12.7617C78.1128 12.1107 78.0314 11.4963 77.8687 10.9185C77.714 10.3325 77.478 9.81576 77.1606 9.36816C76.8514 8.91243 76.4608 8.55436 75.9888 8.29395C75.5249 8.03353 74.9797 7.90332 74.353 7.90332C73.7345 7.90332 73.1893 8.03353 72.7173 8.29395C72.2534 8.55436 71.8628 8.91243 71.5454 9.36816C71.2362 9.81576 71.0042 10.3325 70.8496 10.9185C70.695 11.4963 70.6177 12.1107 70.6177 12.7617ZM85.4736 8.36719V19.5H83.2153V6.29199H85.4126L85.4736 8.36719ZM89.5996 6.21875L89.5874 8.31836C89.4002 8.27767 89.2212 8.25326 89.0503 8.24512C88.8875 8.22884 88.7004 8.2207 88.4888 8.2207C87.9679 8.2207 87.5081 8.30208 87.1094 8.46484C86.7106 8.6276 86.3729 8.85547 86.0962 9.14844C85.8195 9.44141 85.5998 9.79134 85.437 10.1982C85.2824 10.597 85.1807 11.0365 85.1318 11.5166L84.4971 11.8828C84.4971 11.0853 84.5744 10.3366 84.729 9.63672C84.8918 8.93685 85.14 8.31836 85.4736 7.78125C85.8073 7.236 86.2305 6.81283 86.7432 6.51172C87.264 6.20247 87.8825 6.04785 88.5986 6.04785C88.7614 6.04785 88.9486 6.0682 89.1602 6.10889C89.3717 6.14144 89.5182 6.17806 89.5996 6.21875ZM93.9331 8.9165V19.5H91.6626V6.29199H93.811L93.9331 8.9165ZM93.4692 12.3955L92.4194 12.3589C92.4276 11.4556 92.5456 10.6214 92.7734 9.85645C93.0013 9.08333 93.339 8.41195 93.7866 7.84229C94.2342 7.27262 94.7917 6.83317 95.459 6.52393C96.1263 6.20654 96.8994 6.04785 97.7783 6.04785C98.3968 6.04785 98.9665 6.13737 99.4873 6.31641C100.008 6.4873 100.46 6.75993 100.842 7.13428C101.225 7.50863 101.522 7.98877 101.733 8.57471C101.945 9.16064 102.051 9.86865 102.051 10.6987V19.5H99.7925V10.8086C99.7925 10.1169 99.6745 9.56348 99.4385 9.14844C99.2106 8.7334 98.8851 8.43229 98.4619 8.24512C98.0387 8.0498 97.5423 7.95215 96.9727 7.95215C96.3053 7.95215 95.7479 8.07015 95.3003 8.30615C94.8527 8.54215 94.4946 8.86768 94.2261 9.28271C93.9575 9.69775 93.7622 10.1738 93.6401 10.7109C93.5262 11.2399 93.4692 11.8014 93.4692 12.3955ZM102.026 11.1504L100.513 11.6143C100.521 10.89 100.639 10.1942 100.867 9.52686C101.103 8.85954 101.44 8.26546 101.88 7.74463C102.327 7.2238 102.877 6.81283 103.528 6.51172C104.179 6.20247 104.924 6.04785 105.762 6.04785C106.47 6.04785 107.096 6.14144 107.642 6.32861C108.195 6.51579 108.659 6.80469 109.033 7.19531C109.416 7.5778 109.705 8.07015 109.9 8.67236C110.095 9.27458 110.193 9.99072 110.193 10.8208V19.5H107.922V10.7964C107.922 10.0558 107.804 9.4821 107.568 9.0752C107.34 8.66016 107.015 8.37126 106.592 8.2085C106.177 8.0376 105.68 7.95215 105.103 7.95215C104.606 7.95215 104.167 8.0376 103.784 8.2085C103.402 8.37939 103.08 8.6154 102.82 8.9165C102.559 9.20947 102.36 9.5472 102.222 9.92969C102.091 10.3122 102.026 10.7191 102.026 11.1504Z"
                fill="white"
              />
            </svg>
          </div>
        </div>

        <div class="left_container__item namespace">
          <label>{{ getNamespace }}</label>
        </div>
      </div>
      <div class="bar_container__item right_container">
        <div class="right_container__item user_info_container">
          <div class="user_info_container__item user_button">
            <button
                title="Профиль"
                @click="showUserMenu = !showUserMenu"
                v-on-click-outside="[
                    () => showUserMenu = false,
                    { ignore: [] },
                    ]"
            >
              <label>{{userInitials}}</label>
            </button>
            <Transition name="menu">
              <div v-if="showUserMenu" class="user_menu">
                <div class="user_menu_content_container">
                  <div class="user_menu_content_container__item user_info">
                    <div v-if="userInfo.fullName" class="user_info__item full_name">{{userInfo.fullName}}</div>
                    <div v-if="userInfo.login" class="user_info__item login">{{userInfo.login}}</div>
                  </div>
                  <div class="user_menu_content_container__item ssh">
                    <button @click="showSSHEditor">SSH ключ</button>
                  </div>
                  <div class="user_menu_content_container__item">
                    <button @click="onLogout">Выход</button>
                  </div>
                </div>
              </div>
            </Transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { namespace } from "@/config";
import { logout } from "@/auth";
import {defineAsyncComponent, defineComponent} from 'vue'
import {getUserInfo} from "@/utils";
import {vOnClickOutside} from "@vueuse/components";

interface Settings {
  ssh: string | null;
}

interface Info {
  fullName: string | null;
  login: string | null;
  settings: Settings;
}

interface SSHEditor {
  show: boolean;
}

export default defineComponent({
  components: {
    "ssh-editor": defineAsyncComponent(
        () => import("@/components/TopBar/SSHEditor.vue"),
    ),
  },
  directives: {
    onClickOutside: vOnClickOutside,
  },
  name: "TopBar",
  data() {
    return {
      hide: false as boolean,
      showUserMenu: false as boolean,
      userInfo: {
        fullName: null,
        login: null,
        settings: {}
      } as Info,
      sshEditor: {
        show: false,
      } as SSHEditor,
    };
  },
  methods: {
    logout,
    // switch hide state
    async onLogout() {
      await this.logout(this);
    },
    switchHide() {
      this.hide = !this.hide;
      (this as any).$emit("switchHideEvent", this.hide);
    },
    goFirstPage() {
      this.$router.push("/terminals");
    },

    showSSHEditor() {
      this.sshEditor.show = true;
    },

    async onUpdateSSH() {
      await getUserInfo(this.$http)
      this.fillUserInfoFromStorage()
    },

    fillUserInfoFromStorage() {
      this.userInfo.fullName = this.$store.getters.USER_DATA.fullName;
      this.userInfo.login = this.$store.getters.USER_DATA.login;
      this.userInfo.settings = this.$store.getters.USER_DATA.settings;
    }

  },
  computed: {
    getNamespace() {
      return namespace;
    },
    isSnowing() {
      const date = new Date();
      return date.getMonth() === 11;
    },
    userInitials(): string {
      if (this.userInfo.fullName) {
        return this.userInfo.fullName
            .split(" ")
            .slice(0,2)
            .map((w: string) => w.substring(0, 1).toUpperCase()).join("");
      } else if (this.userInfo.login) {
        return this.userInfo.login
            .split("_")
            .slice(0,2)
            .map((w: string) => w.substring(0, 1).toUpperCase()).join("")
      }
      return "??"
    }
  },
  mounted() {
    this.fillUserInfoFromStorage()
  },
});
</script>

<style lang="less">
@import "~@/assets/styles/animations.less";
@import "~@/assets/styles/colors.less";
#top_bar {
  .menu-enter-from {
    opacity: 0;
    filter: blur(3px);
    transform: scaleY(0.6);
  }

  .menu-leave-to {
    opacity: 0;
    filter: blur(3px);
    transform: scaleY(0.5);
  }

  .menu-enter-active {
    transition: all 0.2s ease-out;
    transform-origin: top;
  }
  .menu-leave-active {
    transition: all 0.2s ease-out;
    transform-origin: top;
  }

  .menu-enter-to,
  .menu-leave-from {
    opacity: 1;
    transform: scaleY(1);
  }



  .bar_container {
    background-color: #4150b7;
    height: 50px;
    display: flex;
    align-items: center;
    padding: 11px 51.89px 11px 17.75px;
    justify-content: space-between;

    button {
      all: unset;
      padding: 10px 7px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      &:hover {
        background-color: #d7d8d42f;
        border-radius: 30%;
        transition: 0.7s;
      }
    }

    .bar_container__item {
      &.left_container {
        display: flex;
        align-items: center;

        .left_container__item {
          &.hide_button {
            transform: scaleX(-1);
            &.reversed {
              transform: unset;
            }
          }
        }

        .logo_container {
          display: flex;
          margin-left: 18.75px;
          .logo_container__item {
            order: 0;
          }
          &:hover {
            cursor: pointer;
          }
        }
        .namespace {
          color: #ffffff91;
          margin-left: 5px;
          font-weight: 100;
        }
      }
      &.right_container {

        .user_button {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 40px;
          height: 40px;

          button {
            display: flex;
            align-items: center;
            justify-content: center;
            color: @contrast-color;
            border-radius: 50%;
            background-color: #fffffff0;
            box-shadow: 3px 3px 20px rgba(0, 0, 0, 0.3);
            cursor: pointer;
            padding: 10px;
            transform-origin: center;
            &:hover {
              border: 5px solid #4a65c7f5;
              padding: 10px;
              transition: 0.5s;
              transform-origin: center;
              cursor: pointer;
            }
            label {
              cursor: pointer;
              display: flex;
              justify-content: center;
              align-items: center;
              height: 20px;
              width: 20px;
            }
          }

          .user_menu {
            position: absolute;
            flex-wrap: nowrap;
            top: 60px;
            right: 30px;
            z-index: 5;

            &::before {
              content: "";
              display: block;

              background-color: @background-color;
              width: 15px;
              height: 7px;
              margin-bottom: -3px;
              margin-left: 161px;

              clip-path: polygon(50% 0%, 100% 100%, 0% 100%);
                      }


            .user_menu_content_container {
              padding: 5px;
              position: relative;
              display: flex;
              flex-direction: column;
              align-items: center;
              width: 200px;
              border-radius: 10px;
              font-size: 14px;

              background-color: #ffffff;
              box-shadow:
                0px 11px 15px -7px rgba(0, 0, 0, 0.03),
                0px 24px 38px 3px rgba(0, 0, 0, 0.04),
                0px 9px 46px 8px rgba(0, 0, 0, 0.04);
              .user_menu_content_container__item {
                width: 100%;
                margin-top: 2px;
              }

              button {
                cursor: pointer;
                all: unset;
                width: 100%;
                height: 35px;
                display: flex;
                justify-content: center;
                align-items: center;


                &:hover {
                  background-color: #4151b720;
                  border-radius: 10px;
                  transition: 0.5s;
                  cursor: pointer;
                }
              }

              .user_info {
                display: flex;
                gap: 2px;
                flex-direction: column;
                padding: 10px;
                border-bottom: 1px solid #62616836;
                margin-bottom: 5px;
                align-self: flex-start;
                box-sizing: border-box;
                .full_name {
                  font-weight: bold;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
                .login {
                  color: #626168;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }

              }

            }
          }
        }
      }
    }
  }
}

.snow {
  width: 100%;
  height: 90px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background-image: url("data:image/svg+xml,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 50 50' style='enable-background:new 0 0 50 50%3B' xml:space='preserve'%3E%3Cstyle type='text/css'%3E.st1%7Bopacity:0.3%3Bfill:%23FFFFFF%3B%7D.st3%7Bopacity:0.1%3Bfill:%23FFFFFF%3B%7D%3C/style%3E%3Ccircle class='st1' cx='5' cy='8' r='1'/%3E%3Ccircle class='st1' cx='38' cy='3' r='1'/%3E%3Ccircle class='st1' cx='12' cy='4' r='1'/%3E%3Ccircle class='st1' cx='16' cy='16' r='1'/%3E%3Ccircle class='st1' cx='47' cy='46' r='1'/%3E%3Ccircle class='st1' cx='32' cy='10' r='1'/%3E%3Ccircle class='st1' cx='3' cy='46' r='1'/%3E%3Ccircle class='st1' cx='45' cy='13' r='1'/%3E%3Ccircle class='st1' cx='10' cy='28' r='1'/%3E%3Ccircle class='st1' cx='22' cy='35' r='1'/%3E%3Ccircle class='st1' cx='3' cy='21' r='1'/%3E%3Ccircle class='st1' cx='26' cy='20' r='1'/%3E%3Ccircle class='st1' cx='30' cy='45' r='1'/%3E%3Ccircle class='st1' cx='15' cy='45' r='1'/%3E%3Ccircle class='st1' cx='34' cy='36' r='1'/%3E%3Ccircle class='st1' cx='41' cy='32' r='1'/%3E%3C/svg%3E");
  background-position: 0px 0px;
  animation: animatedBackground 10s linear infinite;
  position: absolute;
  pointer-events: none;
}

.snow div {
  width: 100%;
  height: 90px;
  background-image: url("data:image/svg+xml,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 50 50' style='enable-background:new 0 0 50 50%3B' xml:space='preserve'%3E%3Cstyle type='text/css'%3E.st1%7Bopacity:0.7%3Bfill:%23FFFFFF%3B%7D.st3%7Bopacity:0.1%3Bfill:%23FFFFFF%3B%7D%3C/style%3E%3Ccircle class='st3' cx='4' cy='14' r='1'/%3E%3Ccircle class='st3' cx='43' cy='3' r='1'/%3E%3Ccircle class='st3' cx='31' cy='30' r='2'/%3E%3Ccircle class='st3' cx='19' cy='23' r='1'/%3E%3Ccircle class='st3' cx='37' cy='22' r='1'/%3E%3Ccircle class='st3' cx='43' cy='16' r='1'/%3E%3Ccircle class='st3' cx='8' cy='45' r='1'/%3E%3Ccircle class='st3' cx='29' cy='39' r='1'/%3E%3Ccircle class='st3' cx='13' cy='37' r='1'/%3E%3Ccircle class='st3' cx='47' cy='32' r='1'/%3E%3Ccircle class='st3' cx='15' cy='4' r='2'/%3E%3Ccircle class='st3' cx='9' cy='27' r='1'/%3E%3Ccircle class='st3' cx='30' cy='9' r='1'/%3E%3Ccircle class='st3' cx='25' cy='15' r='1'/%3E%3Ccircle class='st3' cx='21' cy='45' r='2'/%3E%3Ccircle class='st3' cx='42' cy='45' r='1'/%3E%3C/svg%3E");
  background-position: 0px 0px;
  animation: animatedBackground 15s linear infinite;
  position: absolute;
  z-index: 100;
}
</style>
